/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Detected_CategoryInputs */

const en_detected_category = /** @type {(inputs: Detected_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detected Category`)
};

const es_detected_category = /** @type {(inputs: Detected_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categoría detectada`)
};

const fr_detected_category = /** @type {(inputs: Detected_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catégorie détectée`)
};

const de_detected_category = /** @type {(inputs: Detected_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erkannte Kategorie`)
};

const ja_detected_category = /** @type {(inputs: Detected_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`検出されたカテゴリ`)
};

const zh_detected_category = /** @type {(inputs: Detected_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`检测到的类别`)
};

const ar_detected_category = /** @type {(inputs: Detected_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الفئة المكتشفة`)
};

const id_detected_category = /** @type {(inputs: Detected_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kategori Terdeteksi`)
};

const it_detected_category = /** @type {(inputs: Detected_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categoria Rilevata`)
};

const ru_detected_category = /** @type {(inputs: Detected_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Определенная категория`)
};

const pt_detected_category = /** @type {(inputs: Detected_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categoria Detectada`)
};

const ko_detected_category = /** @type {(inputs: Detected_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`감지된 카테고리`)
};

/**
* | output |
* | --- |
* | "Detected Category" |
*
* @param {Detected_CategoryInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const detected_category = /** @type {((inputs?: Detected_CategoryInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Detected_CategoryInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_detected_category(inputs)
	if (locale === "es") return es_detected_category(inputs)
	if (locale === "fr") return fr_detected_category(inputs)
	if (locale === "de") return de_detected_category(inputs)
	if (locale === "ja") return ja_detected_category(inputs)
	if (locale === "zh") return zh_detected_category(inputs)
	if (locale === "ar") return ar_detected_category(inputs)
	if (locale === "id") return id_detected_category(inputs)
	if (locale === "it") return it_detected_category(inputs)
	if (locale === "ru") return ru_detected_category(inputs)
	if (locale === "pt") return pt_detected_category(inputs)
	return ko_detected_category(inputs)
});